import webApi from './api'

export class SystemConfigService {
  async getSystemConfig(params) {
    return webApi.get('system-configurations', { params })
  }
}

const systemConfigService = new SystemConfigService()

export default systemConfigService; 